import { call, put, select } from 'redux-saga/effects';
import { getCpZone as getCpZoneAda } from '@gcloud-npm/adabyron.geo.get-cp-zone';
import { WEB_SERVICES } from './webServices';

const contextStore = state => state.context.data;

export function* getDate(params) {
  const { normalizeHttpErrors, reduxUpdate, data } = params;

  try {
    const context = yield select(contextStore);
    const response = yield call(getCpZoneAda, { data, context });
    const date = new Date(response.ts);
    const { successUpdate } = reduxUpdate;
    if (successUpdate) {
      yield put(successUpdate(date));
    }
    return response;
  } catch (error) {
    const { errorUpdate } = reduxUpdate;
    const errorNormalized = yield call(normalizeHttpErrors, WEB_SERVICES.GET_CURRENT_DATE, error);

    if (errorUpdate) {
      yield put(errorUpdate(errorNormalized));
    }

    throw error;
  }
}
